import React, { useEffect, useMemo, useState } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm, Donors, TeamTherm } from "../ui";
import { Logo, ErrorMessage, Spinner, CCAMFlag } from "../elements";
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { useLocation, useSearchParams } from "react-router-dom";

const CHARITY_TYPE = {
  TILTIFY: "tiltify",
  TWITCH: "twitch",
};

const MaxOverlay = ({ overlayStore }) => {
  //TODO use proper router hooks to get if twitch or tiltify

  //TODO use proper router hooks to get params instead of this useEffect daisy chain nonsense
  const [urlParams] = useSearchParams();
  const loc = useLocation();
  const pathParts = useMemo(
    () => loc.pathname.split("/").slice(1),
    [loc.pathname]
  );
  const overlay = pathParts[0];
  const username = pathParts[1];
  const isTwitch = username === CHARITY_TYPE.TWITCH;
  const slug = pathParts[2];

  const queryString = window.location.search;
  const findParam = (param) => {
    if (param) {
      const slug = window.location.pathname.split("/")[4].split("&");

      const paramValue = slug.filter((str) => {
        return str.includes(param);
      });

      if (paramValue.length > 0) {
        return paramValue[0].split("=")[1];
      }

      return null;
    }

    return null;
  };
  //const urlParams = new URLSearchParams(queryString);

  const scrollerShow = urlParams.get("scroller")
    ? urlParams.get("scroller")
    : findParam("scroller");
  const bgColor = urlParams.get("bgColor")
    ? urlParams.get("bgColor")
    : findParam("bgColor");
  const scrollerPosition = urlParams.get("scrollerPosition")
    ? urlParams.get("scrollerPosition")
    : findParam("scrollerPosition");

  // const fake = urlParams.get("fake") ?? findParam("fake") ?? "no";

  const fake = urlParams.get("fake") ? urlParams.get("fake") : "no";

  useEffect(() => {
    if (!isTwitch) {
      /* Remove for production */
      const url = `${process.env.REACT_APP_LOCAL_URI}/max/`;
      /* Remove for production */

      let streamer = window.location.href.replace(url, "").split("/");
      // Tiltify
      if (streamer[0][0] === "@" || streamer[0][0] === "+") {
        streamer[2] = streamer[0][0];
        streamer[0] = streamer[0].substr(1, streamer[0].length);
      } else {
        streamer[2] = "@";
      }

      if (streamer[0] !== "") {
        let streamType = streamer[2],
          username = streamer[0],
          slug = streamer[1];

        /* Remove for production */
        overlayStore.socketConnect(
          streamType,
          username,
          slug,
          null,
          fake === "yes"
        );

        return () => overlayStore.socketDisconnect();
      }
    } else {
      // Twitch

      const twitchOAuthToken = slug;

      overlayStore.twitchSocketConnect(twitchOAuthToken);

      return () => overlayStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  /*  useEffect(() => {
    if (twitchParams) {
      const {  twitchOAuthToken } = twitchParams;

     
      if (initialSocketConnect) {
        overlayStore.twitchSocketConnect(twitchOAuthToken);
        setInitialSocketConnect(false);
      } 
    }
  }, [twitchParams, overlayStore.socket]); */

  // useEffect(() => {
  //   console.log("OVERLAY STORE SOCKET: ", overlayStore.socket);
  // }, [overlayStore.socket]);

  const {
    error,
    isLoading,
    cause,
    status,
    streamType,
    raised,
    progress,
    goalVal,
  } = overlayStore;
  //const { accessToken } = props.userStore;

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div>
      {cause != `${process.env.REACT_APP_TILTIFY_CAUSE_ID}` &&
      cause != "St. Jude Children's Research Hospital" ? (
        <p className="unpublished">
          This campaign is unpublished, retired or not a valid St. Jude
          campaign.
        </p>
      ) : status == "published" ? (
        <div className="max-overlay">
          {AnalyticsEvent("english", "/", "PLAY LIVE Max Overlay")}
          <div
            className={
              scrollerShow === "yes"
                ? "max-overlay__left"
                : "max-overlay__left small"
            }
          >
            {scrollerShow === "yes" ? <Logo /> : <LogoSmall />}
          </div>

          <div
            className="max-overlay__right"
            style={{
              height: `${scrollerShow === "yes" ? "" : "60px"}`,
            }}
          >
            {scrollerShow === "yes" && scrollerPosition === "top" ? (
              <Donors findParam={findParam} />
            ) : (
              ""
            )}
            {/* {streamType === "@" || streamType === "twitch" ? (
              <Therm
                raised={raised}
                progress={progress}
                goal={goalVal}
                bgColor={bgColor}
                type="campaign"
              />
            ) : streamType === "+" ? (
              <TeamTherm />
            ) : (
              ""
            )} */}
            <Therm
              raised={raised}
              progress={progress}
              goal={goalVal}
              bgColor={bgColor}
              type="campaign"
              overlay="max"
            />
            {scrollerShow === "yes" && scrollerPosition === "bottom" ? (
              <Donors findParam={findParam} />
            ) : (
              ""
            )}
          </div>
          {bgColor === "ccam" ? <CCAMFlag /> : ""}
        </div>
      ) : (
        <p className="unpublished">
          This campaign is unpublished, retired or not a valid St. Jude
          campaign.
        </p>
      )}
    </div>
  );
};

export default inject("overlayStore")(observer(MaxOverlay));
